
import * as Yup from 'yup'


 export const CreateBillValidation = Yup.object().shape({
      type:Yup.string(),
      bill_no: Yup.string().required(
      ),
      supplier_id: Yup.string().required(
      ),
      date: Yup.string().required(
      ),
      total: Yup.string().required(
      ),
      tax_amount: Yup.string().required(
      ),
      net_after_tax: Yup.number().required(
      ),
      net_after_tax_str: Yup.string().required(
      ),
      paid:
       Yup.string().when('type',
      ([type], schema: Yup.StringSchema)=> type==='Post Paid'?Yup.number().required(
      ).max(Yup.ref('net_after_tax'),
      "can't be more than the total after tax"
      ).test(
        {
          name:'net_after_tax',
          exclusive:false,
          test:function (value) {
            return value <= parseInt(this.parent.net_after_tax)
          }
        }
      )
      :Yup.string()),
    remains: Yup.string().when('type',
      ([type], schema: Yup.StringSchema)=> type==='Post Paid'?Yup.string().required(
      'This Field is required' ,
      ):Yup.string()),
      billdetails: Yup.array().of(
        Yup.object({
          Price: Yup.number()
            .required(

                'This Field is required'

            )
            .min(
              1,
              
                 'This field has to be more than 0'
             
            ),
        }),
      ),
    }
)